<template>
  <div class="w-12">
    <ul class="space-y-2">
      <li>
        <div class="relative inline-block">
          <div
            v-if="task.commentsCount"
            class="bg-red-600 absolute text-white text-xs text-center p-1 -mt-1 -mr-1 top-0 right-0 rounded-full leading-none"
            style="min-width: 1.25rem"
          >
            {{ task.commentsCount }}
          </div>
          <button
            class="w-12 h-12 leading-5 hover:bg-gray-200 rounded focus:outline-none focus:bg-blue-600 focus:text-white inline-flex items-center justify-center"
            @click="$emit('comments:show')"
          >
            <svg viewBox="0 0 24 24" class="w-5 h-5 inline-flex" fill="currentColor">
              <path
                d="M14 22.5L11.2 19H6a1 1 0 0 1-1-1V7.103a1 1 0 0 1 1-1h16a1
                1 0 0 1 1 1V18a1 1 0 0 1-1 1h-5.2L14
                22.5zm1.839-5.5H21V8.103H7V17H12.161L14
                19.298 15.839 17zM2 2h17v2H3v11H1V3a1 1 0 0 1 1-1z"
              />
            </svg>
          </button>
        </div>
      </li>
      <li v-if="hasProject">
        <div class="relative inline-block">
          <div
            v-if="task.assetsCount"
            class="bg-red-600 absolute text-white text-xs text-center p-1 -mt-1 -mr-1 top-0 right-0 rounded-full leading-none"
            style="min-width: 1.25rem"
          >
            {{ task.assetsCount }}
          </div>
          <button
            class="w-12 h-12 leading-5 hover:bg-gray-200 rounded focus:outline-none focus:bg-blue-600 focus:text-white inline-flex items-center justify-center"
            @click="$emit('assets:show')"
          >
            <svg viewBox="0 0 24 24" class="w-5 h-5 inline-flex" fill="currentColor">
              <path
                d="M14.828 7.757l-5.656 5.657a1 1 0 1 0 1.414 1.414l5.657-5.656A3
                3 0 1 0 12 4.929l-5.657 5.657a5 5 0 1 0 7.071 7.07L19.071 12l1.414
                1.414-5.657 5.657a7 7 0 1 1-9.9-9.9l5.658-5.656a5 5 0 0 1 7.07
                7.07L12 16.244A3 3 0 1 1 7.757 12l5.657-5.657 1.414 1.414z"
              />
            </svg>
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'RightToolbar',
  props: {
    hasProject: Boolean,
    task: {
      type: Object,
      required: true,
    },
  },
};
</script>
